
  export default {
    components: {},
    props: {
      locationLink: {
        type: String,
        default: "#"
      },
        locationImage: {
          type: String,
        },
      locationName: {
        type: String,
        default: 'Place Name'
      },
      // locationRatings: {
      //   type: Number,
      //   default: 0
      // },
      locationCity: {
        type: String,
        default: 'City'
      },
      locationCategory: {
        type: String,
        default: 'Category'
      },
      locationBrief: {
        type: String,
        default: 'Description'
      },
      locationDistance: {
        type: Number,
        default: 0
      },
    }
  }

